<template>
    <div class="section" id="sec-news">
        <div class="section-head"><span>News</span></div>
        <a-tabs v-model:activeKey="currentTab">
            <a-tab-pane v-for="tag in tags" :key="tag.type" :tab="tag.name">
                <div v-for="item in filteredNews.slice(0, 6)">
                    <i v-html="item.icon" />&emsp;<span v-html="item.rawHtml"></span><br />
                    <span class="date-text"> {{ item.date }}&nbsp;</span>
                </div>
                <a-collapse v-if="filteredNews.length > 6" v-model:activeKey="activeKey">
                    <a-collapse-panel key="newsmore" header="More">
                        <div v-for="item in filteredNews.slice(6)">
                            <i v-html="item.icon" />&emsp;<span v-html="item.rawHtml"></span><br />
                            <span class="date-text"> {{ item.date }}&nbsp;</span>
                        </div>
                    </a-collapse-panel>
                </a-collapse>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script lang="ts">
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

var news = [
    {
        type: "award",
        date: "2023.10",
        rawHtml:
            "My Ph.D. thesis <span style='font-style:italic;'>Efficient Creation and Analysis of Visualizations for Data Communication</span> won <a class='url' href='https://tc.computer.org/vgtc/awards/vis-doctoral-dissertation-award/'>IEEE VGTC Visualization Doctoral Dissertation Award</a>. I am honored to be the first recipient graduated from Asia.",
    },    {
        type: "travel",
        date: "2023.09",
        rawHtml:
            "Joined ACM CHI 2024 as a member of the program committee!",
    },
    {
        type: "award",
        date: "2023.03",
        rawHtml:
            "My <a class='url' href='https://lbezone.hkust.edu.hk/pdfviewer/web/viewer.php?file=aHR0cHM6Ly9sYmV6b25lLmhrdXN0LmVkdS5oay9vYmovMS9vLzk5MTAxMzEwNjM0NTkwMzQxMi85OTEwMTMxMDYzNDU5MDM0MTIucGRm#page=1'>Ph.D. thesis</a> <span style='font-style:italic;'>Efficient Creation and Analysis of Visualizations for Data Communication</span> was awarded <a class='url' href='https://cse.hkust.edu.hk/News/BestDissertation2021-22/#:~:text=We%20are%20pleased%20to%20announce%20that%20the%20recipient%20of%20the,of%20Visualizations%20for%20Data%20Communication.'>HKUST CSE Best PhD Dissertation Award</a> and a finalist for School of Engineering PhD Research Excellence Award (top 3 from 1000 PhD students in SENG).",
    },
    {
        type: "travel",
        date: "2022.10",
        rawHtml:
            "Organized the panel <a class='url' href='https://ieeevis.org/year/2022/info/panels'>Grand Challenges in Visual Analytic Systems</a> at IEEE VIS 2022.",
    },
    {
        type: "media",
        date: "2022.07",
        rawHtml:
            "<a class='url' href='https://mp.weixin.qq.com/s/KAo_tMcFLTs-k9ewOWIdbg'>Feature story (in Chinese)</a> by HKUST GSAA (Graduate Students and Alumni Association) and <a class='url' href='https://ebookshelf.ust.hk/flippingbook/G22789/#p=23'>feature story</a> in the biannual HKUST Almuni magazine.",
    },
    {
        type: "business",
        date: "2022.06",
        rawHtml:
            "Our research <a class='url' href='https://cerg1.ugc.edu.hk/cergprod/scrrm00542.jsp?proj_id=16210722&old_proj_id=null&proj_title=&isname=Qu&ioname=&institution=&subject=E2&pages=1&year=2022&theSubmit=16210722'>proposal about AI4VIS</a> was awareded over 1M HKD by the General Research Fund, the Research Grants Council (RGC) of Hong Kong.",
    },
    // {
    //     type: "travel",
    //     date: "2022.05",
    //     rawHtml: "I work as a program committee member in IEEE VIS (short paper).",
    // },
    {
        type: "travel",
        date: "2022.04",
        rawHtml: "I gave a talk named a beginner's guide to literature surveys on GAMES-Webinar.",
    },
    {
        type: "award",
        date: "2022.03",
        rawHtml:
            "Our work on visualization embeddings and retrieval received an honorable mention award @CHI 2022!",
    },
    {
        type: "paper",
        date: "2021.11",
        rawHtml:
            "One paper at <span class='url'>IEEE TVCG</span> and another at <span class='url'>ACM CHI 2022</span>.",
    },
    {
        type: "award",
        date: "2021.10",
        rawHtml:
            "I am awarded <a class='url' href='https://www.microsoft.com/en-us/research/academic-program/phd-fellowship/#!people'>Microsoft Research 2021/22 PhD Fellow</a>.",
    },
    {
        type: "paper",
        date: "2021.07",
        rawHtml:
            "Our paper at <span class='url'>IEEE VIS 2021</span>, and the survey about AI4VIS was accepted to <span class='url'>IEEE TVCG</span>.",
    },
    {
        type: "media",
        date: "2021.06",
        rawHtml:
            "I led the team to set up the Wechat Official Accounts and Blog of the <a href='http://vis.cse.ust.hk/' class='url'>HKUST VisLab</a>. Our first article introduces to the public what is visualization research and was viewed for more than 2k times on the day of publication.",
    },
    {
        type: "travel",
        date: "2021.06",
        rawHtml:
            'I gave talks at Tongji/Fudan/Shandong University and the GAMES-Webinar, where I described the research vision of "empowering visualizations with AI: from data visualization to visualization data" (<a href="https://drive.google.com/file/d/1_Ihmdf9_M9Ee5RAmYoLF9Whu1DLUeFXp/view?usp=sharing" class="url">slides</a>).',
    },
    {
        type: "paper",
        date: "2021.05",
        rawHtml:
            "I passed my <a href='http://www.cse.ust.hk/pg/defenses/S21/awuac-28-05-2021.html' class='url'>PhD Qualifying Examination<a/>, which was a survey about AI4VIS.",
    },
    {
        type: "business",
        date: "2021.03",
        rawHtml:
            "Our research on <a href='https://patents.google.com/patent/US20210073526A1/en' class='url'>video analysis</a> and <a href='https://patents.google.com/patent/US20200273450A1/en' class='url'>speech analysis</a> was patented and integrated into Own The Room’s virtual training app.",
    },
    {
        type: "paper",
        date: "2020.12",
        rawHtml:
            "Our paper about automated chart layout configuration is accepted at <span class='url'>ACM CHI 2021</span>.",
    },
    {
        type: "travel",
        date: "2020.10",
        rawHtml:
            "Started internship at Software Analytics Group, Microsoft Research Asia (MSRA) @Beijing.",
    },
    {
        type: "travel",
        date: "2020.10",
        rawHtml: "Served as student volunteer (SV) for IEEE VIS 2020.",
    },
    {
        type: "paper",
        date: "2020.08",
        rawHtml: "Two papers accepted at <span class='url'>IEEE VIS 2020</span>.",
    },
    {
        type: "paper",
        date: "2019.12",
        rawHtml: "One co-authored paper accepted at <span class='url'>ACM CHI 2020</span>.",
    },
    {
        type: "award",
        date: "2019.11",
        rawHtml:
            'Won the Research & Development award at the 19th Asia Pacific Information and Communications Technology Alliance (APICTA) Awards @Ha Long, Vietnam (see the <a href="https://www.info.gov.hk/gia/general/201911/23/P2019112300065.htm?fontSize=1" class="url">press release by the government of HKSAR</a>).',
    },
    {
        type: "award",
        date: "2019.09",
        rawHtml:
            'Started my PhD journey with the <a href="https://cerg1.ugc.edu.hk/hkpfs/index.html" class="url">Hong Kong PhD Fellowship Scheme</a>.',
    },
    {
        type: "paper",
        date: "2019.07",
        rawHtml: 'One co-authored paper accepted at <span class="url">IEEE VIS 2019</span>.',
    },
    // { type: "travel", date: "2019.06", rawHtml: 'Attended Eurovis @Porto, Portugal and DTU Green Challenge @Copenhagen, Denmark.' },
    {
        type: "business",
        date: "2019.06",
        rawHtml:
            'My work on educational video analysis received the Hong Kong <a class="url" href="https://www.itf.gov.hk/en/home/index.html">ITF</a> funding titled AI-powered Visual Analytics Solutions for Communication and Presentation Coaching.',
    },
    {
        type: "media",
        date: "2019.05",
        rawHtml:
            'Two feature stories about our smart campus project on <a href="https://www.scmp.com/news/hong-kong/education/article/3003997/making-long-queues-thing-past-goal-two-computing-science" class="url">SCMP</a> and <a href="http://www.takungpao.com.hk/231106/2019/0430/281981.html" class="url">Ta Kung Pao</a>.',
    },
    // { type: "travel", date: "2019.04", rawHtml: 'Attended Pacific VIS @Bangkok, Thailand.' },
    {
        type: "award",
        date: "2019.04",
        rawHtml:
            'Won the Gold Award at the Hong Kong ICT Award <a href="https://www.hkictawards.hk/" class="url">(HKICT 2019)</a>.',
    },
    {
        type: "business",
        date: "2019.01",
        rawHtml:
            "Our project Pulse of HKUST was <a href='https://ssc.ust.hk/' class='url'>selected</a> as one of the first seven HKUST Sustainable Smart Campus as a Living Lab initiatives and received a funding of 2.6M HKD.",
    },
    {
        type: "media",
        date: "2018.12",
        rawHtml:
            "Feature story on the School of Engineering yearbook <a class='url' href='https://www.seng.ust.hk/web/publication/infocus/no30/mobile/index.html#p=24/'>In Focus</a>.",
    },
    {
        type: "paper",
        date: "2018.11",
        rawHtml: "My first paper accepted at <span class='url'>IEEE TVCG</span>.",
    },
    {
        type: "business",
        date: "2018.09",
        rawHtml:
            'I lead the team to release the first demo, which visualized the real-time crowdedness such as waiting time at bus stops and available seats at canteens. It was briefly covered by the <a href="http://www.huamin.org/images/pulse_singpao.jpg" class="url">Sing Pao Daily.</a>',
    },
] as any[];

news = news.filter((x) => x.type !== "paper");

const getIconByType = (e: string) => {
    switch (e) {
        case "paper":
            return '<i class="fas fa-print" style="color:#247BA0"></i>';
        case "award":
            return '<i class="fas fa-trophy" style="color:#94771e;"></i>';
        case "travel":
            return '<i class="fas fa-briefcase" style="color:#F25F5C;"></i>';
        case "media":
            return '<i class="fas fa-newspaper" style="color:#b38eb3"></i>';
        case "business":
            return '<i class="fas fa-registered" style="color:#484D6D"></i>';
    }
};

const tags = [
    {
        type: "all",
        name: "All",
    },
    {
        type: "award",
        name: "Award",
    },
    // {
    //     type: "paper",
    //     name: "Academic",
    // },
    {
        type: "business",
        name: "R&D",
    },
    {
        type: "media",
        name: "Media",
    },
    {
        type: "travel",
        name: "Outreach",
    },
];

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const state = reactive({
            currentTab: "all",
            activeKey: "",
        });

        for (let n of news) {
            n.icon = getIconByType(n.type);
        }

        var filteredNews = computed(() => {
            if (state.currentTab === "all") return news;
            else {
                var type = tags.find((x) => x.type === state.currentTab)?.type;

                if (type !== undefined) {
                    return news.filter((x) => x.type === type);
                }
            }
        });

        return {
            ...toRefs(state),
            news,
            tags,
            filteredNews,
        };
    },
    computed: {},
});
</script>

<style rel="stylesheet" lang="scss">
div.ant-tabs-tab {
    margin-right: 2px !important;
}

div#sec-news {
    padding-bottom: 30px;

    .ant-collapse {
        font-size: 15px !important;
    }
    .ant-tabs {
        font-size: 15px !important;
    }

    .ant-collapse {
        margin-left: -16px;
        border: none;
    }

    .ant-collapse-header {
        background-color: #f5f5f7;
    }

    .ant-collapse-content {
        background-color: #f5f5f7;
        border: none;
    }
}
</style>
